/**
 * @desc 获取免登授权Token
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.IotTokenResponse>> {
  return defHttp.get({
    url: '/web/iot/login/getAccessToken',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.IotTokenResponse>> {
  return defHttp.get({
    url: '/mock/web/iot/login/getAccessToken',
  });
}
